import { createModalStore } from '@/shared/lib/modal';

import type { TrialPlan } from './PLANS';

/**
 * Хук стора модалки TrialPaywall.
 * Позволяет открывать/закрывать пейволл глобально из любого места приложения.
 * Также поддерживает передачу предвыбранного плана через open({ preSelectedPlanName }).
 */
const initialState: { title?: string; preSelectedPlanName?: null | TrialPlan['name'] } = {
  title: 'Unlock all download options',
  preSelectedPlanName: null,
};

export const useTrialPaywallModalStore = createModalStore<typeof initialState>(initialState);
